import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import CreateSession from "./pages/CreateSession";
import FacilitatorDashboard from "./pages/FacilitatorDashboard";
import JoinSession from "./pages/JoinSession";
import ParticipantView from "./pages/ParticipantView";
import AdminPanel from "./pages/AdminPanel";
import PresentationView from "./pages/PresentationView";
import StationView from "./pages/StationView";
import WelcomeScreen from "./pages/WelcomeScreen";
import GuidePage from "./pages/GuidePage";
import HostStationView from "./pages/HostStationView";
import { ThemeProvider } from "./context/ThemeContext";
import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <div className="App min-h-screen mesh-bg">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/create" element={<CreateSession />} />
            <Route path="/facilitator/:sessionId" element={<FacilitatorDashboard />} />
            <Route path="/join" element={<JoinSession />} />
            <Route path="/join/:code" element={<JoinSession />} />
            <Route path="/session/:sessionId" element={<ParticipantView />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/present/:sessionId" element={<PresentationView />} />
            <Route path="/station/:sessionId/:stationIndex" element={<StationView />} />
            <Route path="/welcome/:sessionId" element={<WelcomeScreen />} />
            <Route path="/guide" element={<GuidePage />} />
            <Route path="/host/:hostKey" element={<HostStationView />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
